import moment from "moment"
import { createSelector } from "reselect"

// selectors
import { selectDashboardsValue } from "app/static/frontend/dashboards/selectors"

// action creators
import { globalDateButtonOnClick } from "app/static/frontend/dashboards/action-creators/dashboardHeaderActionCreators"

export const selectDashboardWidgetsGlobalDate =
    createSelector(
        (_, props) => props.widgets,
        (widgets) => {
            const widgetValues = (
                widgets &&
                Object.values(widgets)
            )

            if (widgetValues) {
                for (const widgetValue of widgetValues) {
                    if (widgetValue.data_sources) {
                        for (const dataSource of widgetValue.data_sources) {
                            if (dataSource.safed_search) {
                                const dataType = (
                                    dataSource
                                        .safed_search
                                        .data_type
                                )
                                const dateField = DjangIO.app.search.types.QuorumDataTypeOrdering.by_data_type_date_range[
                                    dataType
                                ]
                                const customDateField = DjangIO.app.search.types.QuorumDataTypeOrdering.by_data_type_default_date[
                                    dataType
                                ]

                                const getGlobalDateCustom = () => {
                                    const additionalFilters = dataSource.additional_filters

                                    if (
                                        additionalFilters &&
                                        Object.keys(additionalFilters).length
                                    ) {
                                        const globalDateCustomFrom = dataSource.additional_filters[`${customDateField}__gt`]
                                        const globalDateCustomTo = dataSource.additional_filters[`${customDateField}__lt`]
                                        if (
                                            globalDateCustomFrom ||
                                            globalDateCustomTo
                                        ) {
                                            const globalDateCustom = []

                                            if (globalDateCustomFrom) {
                                                globalDateCustom.push(
                                                    moment(globalDateCustomFrom).format("MMM DD, YYYY")
                                                )
                                            }

                                            if (globalDateCustomTo) {
                                                globalDateCustom.push(
                                                    moment(globalDateCustomTo).format("MMM DD, YYYY")
                                                )
                                            }

                                            return globalDateCustom.join(" - ")
                                        }
                                    }

                                    return undefined
                                }

                                const getGlobalDateStandard = () => {
                                    const additionalFilters = dataSource.additional_filters

                                    if (
                                        additionalFilters &&
                                        Object.keys(additionalFilters).length
                                    ) {
                                        return dataSource.additional_filters[dateField]
                                    }

                                    return undefined
                                }

                                const globalDateCustom = getGlobalDateCustom()
                                const globalDateStandard = getGlobalDateStandard()

                                if (globalDateCustom || globalDateStandard) {
                                    return (
                                        globalDateCustom ||
                                        globalDateStandard
                                    )
                                }
                            }
                        }
                    }
                }
            }

            return undefined
        }
    )

export const selectGlobalDateButtonText = createSelector(
    selectDashboardWidgetsGlobalDate,
    (globalDate) => {
        if (globalDate) {
            const globalDateEnum = DjangIO.app.events.models.DateRangeType.by_value(
                globalDate
            )

            return (
                globalDateEnum
                    ? globalDateEnum.label
                    // custom date
                    : globalDate
            )
        }

        return "Set Date Range"
    }
)

export const selectGlobalDateDropdownMenuOptions = createSelector(
    selectDashboardWidgetsGlobalDate,
    (_, props) => props.createOrUpdateDashboard,
    (_, props) => props.deletedWidgets,
    (_, props) => props.destroyDashboardStore,
    (_, props) => props.id,
    (_, props) => props.name,
    (_, props) => props.sendAction,
    (_, props) => props.setDashboardsValues,
    (_, props) => props.widgets,
    (
        globalDate,
        createOrUpdateDashboard,
        deletedWidgets,
        destroyDashboardStore,
        id,
        name,
        sendAction,
        setDashboardsValues,
        widgets,
    ) => {
        const dateRangeTypeItems = [
            ...[DjangIO.app.events.models.DateRangeType.future],
            ...DjangIO.app.events.models.DateRangeType.region_supported_items()
                .filter(dateRangeType => !dateRangeType.is_future)
        ]

        return [
            ...dateRangeTypeItems
                .sort(DjangIO.orderSort)
                .map(dateRangeType => (
                    {
                        ...dateRangeType,
                        isActive: (
                            globalDate &&
                            DjangIO.app.events.models.DateRangeType.by_value(globalDate) &&
                            (
                                DjangIO.app.events.models.DateRangeType.by_value(globalDate).label ===
                                dateRangeType.label
                            )
                        ),
                        onClick: () => globalDateButtonOnClick({
                            dateRangeType: dateRangeType.value,

                            createOrUpdateDashboard,
                            destroyDashboardStore,
                            deletedWidgets,
                            id,
                            name,
                            sendAction,
                            setDashboardsValues,
                            widgets,
                        }),
                        text: dateRangeType.label,
                    }
                )),
            ...[
                {
                    isActive: (
                        globalDate &&
                        typeof globalDate === "string"
                    ),
                    onClick: () => {
                        setDashboardsValues({
                            id,
                            values: {
                                globalDateShouldRenderCustomDatePicker: true,
                            }
                        })
                    },
                    text: "Custom Range",
                },
                ...(
                    globalDate
                        ? [{
                            onClick: () => globalDateButtonOnClick({
                                createOrUpdateDashboard,
                                destroyDashboardStore,
                                deletedWidgets,
                                id,
                                name,
                                sendAction,
                                setDashboardsValues,
                                widgets,
                            }),
                            text: "Clear",
                        }]
                        : []
                ),
            ]
        ]
    }
)
